import { useEffect, useState } from "react";
import { getClientsList } from "../../services/client";
import { getWastecategoryList } from "../../services/waste";
import {
  buildWasteCategorySelectOptions,
  buildWasteOriginSelectOptions,
} from "./photoCaptureMobileUtils";

export function useWasteMetadataSelectOptions(enabled = true) {
  const [clientOptions, setClientOptions] = useState([]);
  const [wasteCategoryOptions, setWasteCategoryOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    setLoadError(null);

    Promise.all([
      getClientsList(),
      getWastecategoryList({
        keywordFilter: "",
        listUnCodeFullFilter: {},
        listUnCodeEmptyFilter: {},
        listWasteCodeFullFilter: {},
        listWasteCodeEmptyFilter: {},
        sortByField: "label",
        orderSortByField: "1",
      }),
    ])
      .then(([clientsRes, wasteRes]) => {
        if (cancelled) {
          return;
        }
        const clients = clientsRes?.data?.data ?? [];
        const wasteList = wasteRes?.data?.data ?? [];
        setClientOptions(buildWasteOriginSelectOptions(clients));
        setWasteCategoryOptions(buildWasteCategorySelectOptions(wasteList));
      })
      .catch((error) => {
        if (!cancelled) {
          setLoadError(error);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return {
    clientOptions,
    wasteCategoryOptions,
    isLoading,
    loadError,
  };
}

export function findClientOptionValue(clientOptions, clientData) {
  if (!clientData || !clientOptions.length) {
    return "";
  }

  if (clientData._id) {
    const matchById = clientOptions.find((option) => {
      try {
        return JSON.parse(option.value)._id === clientData._id;
      } catch {
        return false;
      }
    });
    if (matchById) {
      return matchById.value;
    }
  }

  const matchByName = clientOptions.find((option) => {
    try {
      const parsed = JSON.parse(option.value);
      return (
        parsed.name === clientData.name &&
        (parsed.address || "") === (clientData.address || "")
      );
    } catch {
      return false;
    }
  });
  return matchByName?.value ?? "";
}

export function findWasteCategoryOptionValue(
  wasteCategoryOptions,
  wasteCategoryData,
) {
  if (!wasteCategoryData || !wasteCategoryOptions.length) {
    return "";
  }

  const match = wasteCategoryOptions.find((option) => {
    try {
      const parsed = JSON.parse(option.value);
      return (
        (wasteCategoryData.id && parsed.id === wasteCategoryData.id) ||
        (wasteCategoryData.wasteCategoryName &&
          parsed.wasteCategoryName === wasteCategoryData.wasteCategoryName)
      );
    } catch {
      return false;
    }
  });
  return match?.value ?? "";
}
